import {Component, Input, OnInit} from '@angular/core';
import {ApplicationService} from '../../services/application.service';
import {ExgEventArgs} from '../../misc/classes/ExgEventArgs';
import {ExcTranslation} from 'exc-core-v2';
import {EnumerationService} from '../../services/enumeration.service';
import {ExcRestService} from 'exc-rest-v2';
import {ExgModalService} from 'exc-controls-v2';
import {ExcSecurityService} from 'exc-security-v2';

interface GdvQuittungenMeta {
  title: string;
  description: string;
  quittungType: string;
  isExecuted: boolean;
  isLoading: boolean;
  requiresInput: boolean;
}

@Component({
  selector: 'app-case-gdv-receipt',
  templateUrl: './case-gdv-receipt.component.html'
})
export class CaseGdvReceiptComponent extends ExcTranslation implements OnInit {
  @Input()
  caseID = '';

  @Input()
  tableDrawerIsLoading: any | undefined;

  @Input()
  Events: ExgEventArgs | any;

  @Input()
  SummaryGdvReceipt: any;

  @Input()
  ConfigGdvReceipt: any;

  @Input()
  SummaryAttachmentTable: any;

  @Input()
  ConfigAttachmentTable: any;

  isLoading = false;

  gdvActions: GdvQuittungenMeta[] = [];

  constructor(
    public appSvc: ApplicationService,
    public enumSvc: EnumerationService,
    private excRest: ExcRestService,
    private modalSvc: ExgModalService,
    public excSecurity: ExcSecurityService
  ) {
    super();
  }

  ngOnInit(): void {
    this.initializeActions();
    // this.loadGdvStatus();
    if (this.SummaryGdvReceipt){
      this.updateActionStatus(this.SummaryGdvReceipt);
    }
  }

  initializeActions(): void {
    this.gdvActions = [
      {
        title: 'Auftragsannahme quittieren',
        description: 'Versendet Quittungstyp 4 über GDV-Schnittstelle',
        quittungType: '04',
        isExecuted: false,
        isLoading: false,
        requiresInput: false
      },
      {
        title: 'Terminvereinbarung quittieren',
        description: 'Termin mitteilen (Typ 15) oder Mitteilung senden (Typ 90)',
        quittungType: '15',
        isExecuted: false,
        isLoading: false,
        requiresInput: true
      },
      {
        title: 'Arbeitsergebnis quittieren',
        description: 'Anlage wird zusammen mit Quittungstyp 12 übertragen',
        quittungType: '12',
        isExecuted: false,
        isLoading: false,
        requiresInput: true
      },
      {
        title: 'Arbeitsergebnis quittieren ohne Arbeitslisteneintrag',
        description: 'Diese Quittung wird nur im Archiv des Mandanten abgelegt. Kein Arbeitslisteneintrag.',
        quittungType: '11',
        isExecuted: false,
        isLoading: false,
        requiresInput: true
      }
    ];
  }

  loadGdvStatus(): void {
    if (!this.caseID) {
      return;
    }

  }
  updateActionStatus(gdvReceiptList: any[]): void {
    if (!gdvReceiptList || gdvReceiptList.length === 0) {
      return;
    }
    this.gdvActions.forEach(action => {
      let statusEntry;

      if (action.quittungType === '15') {
        statusEntry = gdvReceiptList.find(
          (entry: any) => entry.quittungType === '15' || entry.quittungType === '90'
        );
      } else {
        statusEntry = gdvReceiptList.find(
          (entry: any) => entry.quittungType === action.quittungType
        );
      }

      if (statusEntry) {
        action.isExecuted = statusEntry.gdvqStatus === 'TRANSFERRED' || statusEntry.gdvqStatus === 'PENDING' || statusEntry.gdvqStatus === 'NEW';
      }
    });
  }

  openAction(action: GdvQuittungenMeta): void {
    if (action.requiresInput) {
      this.modalSvc
        .show('ModalGdvReceiptComponent', {
          action,
          caseID: this.caseID,
          attachmentJagData: this.SummaryAttachmentTable?.jagdata
        })
        .subscribe((result: any) => {
          if (result && result.success) {
            action.isExecuted = true;
            this.loadGdvStatus();

            if (this.Events?.GDV?.Sent) {
              this.Events.GDV.Sent.emit({
                success: true,
                quittungType: result.quittungType
              });
            }
          }
        });
    } else {
      this.ConfirmOrderAcceptance(action);
    }
  }

  ConfirmOrderAcceptance(action: GdvQuittungenMeta): void {
    this.modalSvc.showSimple(
      action.title,
      'Möchten Sie die Quittung jetzt versenden?',
      true,
      true,
      'Versenden',
      this.getGlobal('Cancel')
    ).subscribe((confirmed: boolean) => {
      if (confirmed) {
        action.isLoading = true;

        this.excRest
          .post(
            this.excRest.computeUrl('GDVReceiptC', {
              auID: this.caseID
            }),
            {
              quittungType: action.quittungType
            }
          )
          .subscribe(
            (response: any) => {
              action.isLoading = false;

              if (response.success) {
                action.isExecuted = true;

                if (this.Events && this.Events.GDV && this.Events.GDV.Sent) {
                  this.Events.GDV.Sent.emit({
                    success: true,
                    quittungType: action.quittungType
                  });
                }
              }
            }
          );
      }
    });
  }

  ActionStatusText(action: GdvQuittungenMeta): string {
    if (action.isExecuted) {
      return 'Versendet';
    }
    return 'Noch nicht versendet';
  }
}
